let localIdsCounter = 0;
export const generateId = () => {
  return Date.now() * 1000 + localIdsCounter++;
};
